import React, { useEffect, useRef } from "react";
import { mapRecursive, roundDecimal } from "../../../utils";
import "./SunBurstChart.scss";
import { setDashboardSelectedGrouping, useDashboardSelectedGrouping } from "../../../hooks/project";
import { generateSunburstSvgPAST } from "./sunBurstSvgPAST";
import { useTranslation } from "react-i18next";

export const SunBurstChartPAST = ({ data }) => {
  const { i18n } = useTranslation();
  const chartRef = useRef(null);
  const middleRef = useRef(null);
  const selectedGrouping = useDashboardSelectedGrouping();

  const { groupingElements, score } = (data || {});

  useEffect(() => {
    if (chartRef && chartRef.current) {
      chartRef.current.innerHTML = '';

      if (groupingElements && groupingElements.length) {
        const processed = {
          children: mapRecursive(groupingElements, (node, children) => {
            const universalScoreInner = roundDecimal(node.universalScore, 100);

            return {
              uuid: node.uuid,
              value: node.maxSystemScoreProportion,
              universalScore: universalScoreInner,
              title: node.name,
              type: node.type,
              children
            };
          }, 'groupingElements')
        };

        const universalScore = roundDecimal(score, 100);
        chartRef.current.appendChild(generateSunburstSvgPAST({
          data: processed,
          value: selectedGrouping,
          onSelect: setDashboardSelectedGrouping,
          middleContent: middleRef.current,
          score: universalScore
        }));
      }
    }
  }, [groupingElements, selectedGrouping, chartRef]);

  return (
    <div className="sun-burst-chart">
      <div ref={chartRef} className="chart"/>
      <div ref={middleRef} className="middle-content">
        <div className="header-text text-hyphens" lang={i18n.language}/>
        <div className="value-text"/>
      </div>
    </div>
  );
};
